import essApi from '../axios/essApi';

class DomainService {
    async getDomains() {
        return Promise.resolve(essApi.get('domains'))
    }
}

export default DomainService